import { render, staticRenderFns } from "./AlertSettingListScreen.vue?vue&type=template&id=6d962bcd&scoped=true&lang=pug"
import script from "./AlertSettingListScreen.vue?vue&type=script&lang=ts"
export * from "./AlertSettingListScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertSettingListScreen.vue?vue&type=style&index=0&id=6d962bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d962bcd",
  null
  
)

export default component.exports